import Button, { ButtonProps } from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import { AccessResult } from "utils/access";

type PermissionGateButtonProps = ButtonProps & {
  access: AccessResult;
};

const PermissionGateButton = ({ access, ...buttonProps }: PermissionGateButtonProps) => {
  return (
    (access.result || !!access.message) && (
      <Tooltip
        active={!!access.message}
        on={(props) => (
          <Button {...props} {...buttonProps} disabled={!access.result || buttonProps.disabled} />
        )}
      >
        {access.message}
      </Tooltip>
    )
  );
};

export default PermissionGateButton;
